import { computed, ref } from 'vue';

import type { ArticleDecisionAnswer, ArticleDecisionTree } from '~/modules/landing/interfaces';

export function useArticleDecisionTree(tree: ArticleDecisionTree) {
    const steps = tree.finalOutcome ? tree.steps : [];
    const answers = ref<Array<ArticleDecisionAnswer>>([]);

    const currentStepIndex = computed(() => Math.min(answers.value.length, steps.length - 1));
    const currentStep = computed(() => steps[currentStepIndex.value]);
    const canGoBack = computed(() => answers.value.length > 0);

    const outcome = computed<string | null>(() => {
        const lastIndex = answers.value.length - 1;

        if (lastIndex < 0) {
            return null;
        }

        if (answers.value[lastIndex] === steps[lastIndex].decidingAnswer) {
            return steps[lastIndex].outcome;
        }

        if (answers.value.length === steps.length) {
            return tree.finalOutcome;
        }

        return null;
    });

    function isStepDone(index: number): boolean {
        return index < answers.value.length;
    }

    function answer(givenAnswer: ArticleDecisionAnswer) {
        if (outcome.value !== null) {
            return;
        }

        answers.value = [...answers.value, givenAnswer];
    }

    function goBack() {
        answers.value = answers.value.slice(0, -1);
    }

    function restart() {
        answers.value = [];
    }

    return {
        steps,
        currentStepIndex,
        currentStep,
        canGoBack,
        outcome,
        isStepDone,
        answer,
        goBack,
        restart,
    };
}
